<style lang="scss" scoped>
.container {
	width: 100%;
	.dept-strip {
		margin-bottom: 10px;
	}
	.divice-box {
		background-color: #f5f5f5;
		padding: 15px;
		.strip {
			margin-bottom: 10px;
			.device-name {
				font-size: 16px;
				line-height: 16px;
				color: #323232;
				font-weight: bold;
			}
			.device-model {
				font-size: 12px;
				color: #969696;
				margin-left: 9px;
				line-height: 12px;
			}
		}
		.itemList {
			font-size: 15px;
			color: #646464;
			.yuan {
				font-size: 12px;
			}
			/deep/.el-col{
				padding:5px
			}
			
		}
		.el-col {
			display: flex;
		}
	}
	.red {
		color: red;
		font-weight: 700;
		margin-right: 5px;
	}
	.total{
		margin-top: 10px;
		.quantity{
			color: #333;;
			margin-right: 30px;
		}
		.zj{
			font-size: 14px;
			color: #646464;
		}
	}
}
</style>
<template>
	<el-dialog title="购入设备预算详情"
			   :visible.sync="visible"
			   width="1015px"
			   :before-close="beforeClose"
			   custom-class="add-device-info-dialog">
		<div class="bm bm-ver container">
			<div class="dept-strip">
				部门：{{oldDevice.requestDepartName}}
			</div>
			<div class="bm bm-ver divice-box">
				<div class="bm bm-ae strip">
					<span class="device-name">{{oldDevice.deviceName}}</span>
					<span class="device-model">型号：{{oldDevice.deviceModel}}</span>
					<span class="device-model">历史参考价：{{money2(oldDevice.referencePrice)}}/{{oldDevice.baseMeasureUnit}}</span>
				</div>
				<el-row class="bm itemList" :gutter="10">
					<el-col :span="6">
						<div class="bm">到货期：</div>
						<div class="bm bm-f1">
							{{moment(oldDevice.arrivalDate).format("YYYY-MM-DD") }}
						</div>
					</el-col>
					<el-col :span="6">
						<div class="bm">单价： </div>
						<div class="bm bm-f1">{{money2(oldDevice.price)}}&nbsp;(元) </div>
					</el-col>
					<el-col :span="6">
						<div class="bm">驱动因素：</div>
						<div class="bm bm-f1">{{oldDevice.drivingFactor}}</div>
					</el-col>
					<el-col :span="6">
						<div class="bm">需求项目：</div>
						<div class="bm bm-f1">{{oldDevice.projectName}}</div>
					</el-col>
				</el-row>
				<el-row class="bm itemList" :gutter="10">
				</el-row>
				<el-row class="bm itemList" :gutter="10">
					<el-col>
						<div class="bm">详细说明：</div>
						<div class="bm bm-f1">{{oldDevice.description}}</div>
					</el-col>
				</el-row>
			</div>
			<div class="bm bm-pe total">
				<div class="bm quantity">共{{oldDevice.quantity}}{{oldDevice.baseMeasureUnit}}</div>
				<div class="bm zj">总价：</div>
				<div class="bm red">
					￥{{money2(oldDevice.amount)}}&nbsp;(元)
				</div>
			</div>
		</div>
		<div slot="footer" class="dialog-footer">
			<el-button type="primary" @click="beforeClose">我知道了</el-button>
		</div>
	</el-dialog>
</template>
<script>
// const R = require('ramda');
import { deviceApi } from "@/services";
import moment from 'moment'
import $money from "@/utils/money.js"
export default {
	name: "observeDeviceInfo",
	props: {
		visible: {
			type: Boolean,
			required: true
		},
		saveDeviceFrom: {
			type: Object,
			required: true
		}
	},
	data() {
		return {
			moment,
			drivingFactorList: this.$store.state.init.configInfo.drivingFactorList,
			oldDevice: {},
		}
	},
	mounted() {
		// 深度拷贝
		this.oldDevice = JSON.parse(JSON.stringify(this.saveDeviceFrom));

	},
	watch: {
		saveDeviceFrom: {
			handler: function (newValue, oldValue) {
				if (newValue) {
					this.oldDevice = JSON.parse(JSON.stringify(this.saveDeviceFrom));
					for (let key in this.oldDevice) {
						if (key == "deviceModel" || key == "deviceName" || key == "arrivalDate" || key == "price" || key == "drivingFactor" || key == "projectName") {
							this.oldDevice[key] = (this.oldDevice[key] == "" || this.oldDevice[key] === null) ? "暂无" : this.oldDevice[key]
						}
					}
				}
			},
			immediate: true,
			deep: true
		},
	},
	methods: {
		money2(data){
			return $money(data,2,'')
		},
		beforeClose() {
			this.$emit("closeObserveDevice", false);
		},
		handleChange(value) {
			console.log(value);
		},
		delDeviceRow(e) {
			this.oldDevice.list.splice(e, 1);
		},
		handelClick(n) {
			switch (n) {
				case 0:
					this.$emit("know")
					break;
				case 1:
					this.$emit("confirm")
					break;
				default:
					break
			}
		},
	}
}
</script>


